module.exports = __webpack_public_path__ + "static/WEDDING E&M-577-4320e5bdd8e1b1d6a256a793dca18097.jpg";